import { Transition } from 'semantic-ui-react';
export default Transition;
//# sourceMappingURL=index.js.map